import React, { forwardRef, useEffect, useRef,useImperativeHandle } from "react";
import * as d3 from 'd3';

function updateGrid(gridLayer, space_width, gridSize) {
    var gridTicks = [];
    for (var i = 0; i < space_width; i += +gridSize) {
        gridTicks.push(i);
    }

    // 水平线
    gridLayer.selectAll("line.red-ui-workspace-chart-grid-h").remove();
    gridLayer.selectAll("line.red-ui-workspace-chart-grid-h")
        .data(gridTicks)
        .enter()
        .append("line")
        .attr("class", "red-ui-workspace-chart-grid-h")
        .attr("x1", 0)
        .attr("x2", space_width)
        .attr("y1", d => d)
        .attr("y2", d => d);

    // 垂直线
    gridLayer.selectAll("line.red-ui-workspace-chart-grid-v").remove();
    gridLayer.selectAll("line.red-ui-workspace-chart-grid-v")
        .data(gridTicks)
        .enter()
        .append("line")
        .attr("class", "red-ui-workspace-chart-grid-v")
        .attr("y1", 0)
        .attr("y2", space_width)
        .attr("x1", d => d)
        .attr("x2", d => d);
}

const GridLayer = forwardRef(({width, size},ref) => {
    useEffect(() => {
        if (ref.current) {
            const gridLayer = d3.select(ref.current);
            //const gridLayer1 = gridLayer.append("g").attr("class", "red-ui-workspace-chart-grid111");
            
            // 确保 width 和 size 是数字
            updateGrid(gridLayer, Number(width), Number(size));
        }
    }, [width, size]);

    return (<g className="red-ui-workspace-chart-grid" ref={ref} style={{visibility:"visible"}}></g>);
});


export default GridLayer;
